import React from 'react'
import { Card, Button, Icon } from 'semantic-ui-react'
import { Link, withRouter } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getRegionTranslationLabel } from '../../../utils/formNormalization'
import InformationalPopup from '../../../common-components/InformationalPopup'

import { getOperateForCustomerUrl, createRelativePath } from '../../../utils'

export default withRouter(
  ({
    customerId,
    name,
    region,
    tapcustomerId,
    isRelationshipBetweenContracteeAndCbCurrentlyActive,
    renderOperateForButton,
    // provided by withRouter
    match,
  }) => {
    const { t: translate } = useTranslation('common')
    return (
      <Card centered>
        <Card.Content>
          <Card.Header>{name}</Card.Header>
          <Card.Meta>{`${translate('Region')}: ${translate(getRegionTranslationLabel(region))}`}</Card.Meta>
          <Card.Meta>Tap ID: {tapcustomerId}</Card.Meta>
          {!isRelationshipBetweenContracteeAndCbCurrentlyActive && (
            <span>
              <Card.Meta style={{ color: 'red' }}>
                {translate('Inactive')}
                <InformationalPopup
                  popupProps={{ position: 'right center' }}
                  iconName="question"
                  content={translate('inactiveRelationshipToBrewerTooltip')}
                />
              </Card.Meta>
            </span>
          )}
        </Card.Content>
        {renderOperateForButton && (
          <Card.Content extra className="centered-content">
            <Link to={createRelativePath(match, getOperateForCustomerUrl(customerId))}>
              <Button className="testOperateForButton" fluid color="blue" animated>
                <Button.Content visible>{translate('Operate For')}</Button.Content>
                <Button.Content hidden>
                  <Icon name="arrow right" />
                </Button.Content>
              </Button>
            </Link>
          </Card.Content>
        )}
      </Card>
    )
  }
)
